import React from 'react';
import ITestimonialCard from '../../../models/testimonial/ITestimonialCard';
import styles from './testimonial-card-set.module.scss';
import Slider from 'react-slick';
import { Breakpoint } from '../../../constants/breakpoints';
import TestimonialCard from '../testimonials-card/testimonials-card';

interface TestimonialCardSetProps {
  testimonialCards: ITestimonialCard[];
  id?: string;
}

type BtnProps = {
  height?: number;
  onClick?: () => void;
  className?: string;
  style?: any;
};

const CustomBtn = ({ onClick, className, style }: BtnProps) => (
  <button
    className={className}
    aria-label={className}
    onClick={onClick}
    style={{ ...style }}
  ></button>
);

const TestimonialCardSet: React.FC<TestimonialCardSetProps> = ({ testimonialCards, id }) => {
  const settings = {
    dots: true,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    autoplay: false,
    nextArrow: <CustomBtn />,
    prevArrow: <CustomBtn />,
    responsive: [
      {
        breakpoint: Breakpoint.Large,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: Breakpoint.Medium,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: Breakpoint.Small,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  if (!testimonialCards || testimonialCards.length === 0) {
    return <p>No Testimonial Cards Available</p>;
  }

  const renderTestimonialCards = (orientation: 'horizontal' | 'vertical') =>
    testimonialCards.map((card) => (
      <TestimonialCard
        key={card.id}
        orientation={orientation}
        aspectRatio={card.imageTransform}
        image={card.image}
        name={card.name}
        studentCountry={card.studentCountry}
        quote={card.quote}
        jobTitleAndCompany={card.jobTitleAndCompany}
        pathwayCourse={card.pathwayCourse}
        universityDegree={card.universityDegree}
      />
    ));

  return (
    <div
      id={id}
      className={
        testimonialCards.length <= 3
          ? `${styles['testimonial-card-set']} ${styles[`testimonial-card-set-${testimonialCards.length}`]}`
          : 'testimonial-carousel carousel_custom-navs'
      }
    >
      {testimonialCards.length <= 3 ? (
        renderTestimonialCards(testimonialCards.length === 1 ? 'horizontal' : 'vertical')
      ) : (
        <Slider {...settings}>{renderTestimonialCards('vertical')}</Slider>
      )}
    </div>
  );
};

export default TestimonialCardSet;
